import { useAppSelector } from 'shared';

export const useCulinaryStudioPageState = () => useAppSelector(
    (store) => store.culinaryStudioPage,
);
